var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_vm._t("header"),(!_vm.$slots.header)?_c('page-header'):_vm._e(),_c('div',{staticClass:"page-content-wrapper"},[_vm._t("content")],2),_vm._t("footer"),(!_vm.$slots.footer)?_c('page-footer'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }